import type { Section } from "@/pages/human-resources/time-management/business/Section.ts";

export type SectionOut = Omit<Section, "id"> & {
  id: number;
};

export function mapToSection(s: SectionOut): Section {
  return { ...s, id: s.id.toString() };
}
